<template lang='pug'>
#admin.layout( v-if='user && user.email == "admin@bluefaucet.com"' )
  base-modal#edit.biz( :show='edit' )
    modal-wrapper( @close='edit = false' )
      template( v-slot:header )
        h4 Edit Business Slug
      template( v-slot:contents )
        edit-biz( :usr='usr' )

  bf-wrapper.max-1200
    button( @click='list' ) List Users
    
    span.stats(v-if="usrs.length>0") {{ usrs.length}} users
    
    router-link( :to='{ name: "payables"}' ) 
      button.link List Payouts

    table( v-if='usrs.length' )
      tr
        th Username/Email
        th Phone/Zip
        th Business Slug
        th Refer by
        th Verified?
        th Sign-Up Date
        th Disabled?
        th
      tr( v-for='u in usrs') 
        td {{ find( u ).username }}
          p.blue {{ u.email }}
        td {{ find( u ).phone }}
          p {{ find( u ).zip }}
        td
          p.actionable( @click='edify( u )' ) {{ u.displayName }}
        td {{ ref( u ) }}
        td {{ u.emailVerified }}
        td {{ u.metadata.creationTime }}
        td.actionable( @click='status( u )' )
          button.del(v-if="u.disabled==false") 
            span Disable
          button.enable(v-else)
            span Enable
        td.actionable( @click='del( u )' ) 
          button.del Delete
</template>

<script>
import api from '@/lib/apis'
import { db } from '@/main'
import BaseModal from '@/components/modals/base'
import EditBiz from '@/components/forms/biz'
import ModalWrapper from '@/components/modals/wrapper'

export default {
  name: 'admin.layout',

  components: {
    BaseModal,
    ModalWrapper,
    EditBiz
  },

  props: {
    user: { required: true }
  },

  data() {
    return {
      usrs: [],
      acts: [],
      refs: [],
      edit: false,
      usr: null
    }
  },

  firestore() {
    return {
      acts: db.collection( 'accounts' ),
      refs: db.collection( 'referrals' )
    }
  },

  watch: {
    user( cr, pr ) {
      if ( cr && cr.email != 'admin@bluefaucet.com' ) this.$router.push({ name: 'welcome' })
    }
  },

  methods: {
    ref( u ) {
      let ref = this.refs.find( r => r.to && r.to.email == u.email )
      if ( ref ) return ref.by.email
      else return 'N/A'
    },

    edify( u ) {
      this.usr = u
      this.edit = true
    },

    del( u ) {
      let msg = 'Are you SURE you want to PERMANANTLY delete this user and all associated data?'
      let params = { params: { uid: u.uid } }
      let update = r => this.usrs = this.usrs.filter( usr => usr.uid != u.uid )
      if ( confirm( msg ) ) this.$http.get( api.del, params ).then( update )
      else return
    },

    status( u ) {
      u.disabled = !u.disabled
      this.$http.get( api.status, { params: { uid: u.uid, disabled: u.disabled } } )
    },

    find( u ) {
      let act = this.acts.find( a => a.id == u.uid )
      return act ? act : {}
    },

    list() {
      this.$http.get( api.list ).then( r => 
        this.usrs = r.data.filter( u => u.email != 'admin@bluefaucet.com' ) 
      )
    }
  },

  created() {
    if ( this.user && this.user.email != 'admin@bluefaucet.com' ) this.$router.push({ name: 'welcome' })
  }
}
</script>

<style lang='stylus'>
#admin
  padding-top 92px

  button
    border 1px solid
    text-align center
    padding 5px 10px
  
  .link
    margin-left 32px
  .del
    background-color red
    border-radius 5px
    color white
  .enable
    background-color blue
    border-radius 5px
    color white
  .blue
    color blue
    font-weight bold
  .stats
    padding 0px 20px
    font-weight bold
  
  table
    margin 10px 0
    border 1px solid
    text-align left
    tr
      th
        font-weight bold
        padding 10px 10px
        border 1px dotted
        background rgb( 245 245 245 )
      td
        padding 5px 10px
        border 1px dotted
</style>
